import { Field } from '@progress/kendo-react-form';
import React from 'react'; 
import {CusFormLabel} from '../validation/Form-Components';
import appDetailsData from '../data/persondetailsdata.json';
import helper from '../factory/Helper';
import myInfoApiCountries from '../data/myInfoApiCountryList.json';
import config from '../appconfig/config.json';

const PersonResiAddress = (props) => {

    const{seq,applicantDetails} = props;
    
    return(
        <div>
            {applicantDetails.myInfo.REG_ADD_TYPE !== config.addTypeForeign?
            <div>
            <Field component={CusFormLabel} 
                leftLabelId={'lblBlk'+seq} leftLabelName={appDetailsData.label.blk} 
                id={'blk'} name={applicantDetails.myInfo.REG_ADD_BLOCK_NO !== null? applicantDetails.myInfo.REG_ADD_BLOCK_NO:''} />

            <Field component={CusFormLabel} 
                leftLabelId={'lblStreet'+seq} leftLabelName={appDetailsData.label.street} 
                id={'st'} name={applicantDetails.myInfo.REG_ADD_STREET_NAME !==null? applicantDetails.myInfo.REG_ADD_STREET_NAME:''}  />

            <Field component={CusFormLabel} 
                leftLabelId={'lblLvl'+seq} leftLabelName={appDetailsData.label.level} 
                id={'lvl'} name={applicantDetails.myInfo.REG_ADD_FLR_NO !==null? applicantDetails.myInfo.REG_ADD_FLR_NO:''} />

            <Field component={CusFormLabel} 
                leftLabelId={'lblUno'+seq} leftLabelName={appDetailsData.label.unitNo} 
                id={'uno'} name={applicantDetails.myInfo.REG_ADD_UNIT_NO !==null? applicantDetails.myInfo.REG_ADD_UNIT_NO:''} />

            <Field component={CusFormLabel} 
                leftLabelId={'lblbuilding'+seq} leftLabelName={appDetailsData.label.building} 
                id={'bld'} name={applicantDetails.myInfo.REG_ADD_BLDG_NAME !==null? applicantDetails.myInfo.REG_ADD_BLDG_NAME:''}  />

            <Field component={CusFormLabel} 
                leftLabelId={'lblPostalCode'+seq} leftLabelName={appDetailsData.label.postalCode} 
                id={'ptc'} name={applicantDetails.myInfo.REG_ADD_POSTAL_CODE !==null? applicantDetails.myInfo.REG_ADD_POSTAL_CODE:''}  />

            <Field component={CusFormLabel} 
                leftLabelId={'lblcountry'+seq} leftLabelName={appDetailsData.label.country} 
                id={'ctry'} name={applicantDetails.myInfo.REG_ADD_COUNTRY !==null? helper.getLabelInArray(applicantDetails.myInfo.REG_ADD_COUNTRY,myInfoApiCountries):''}  />
            
            </div> 
            :
            <div>
            <Field component={CusFormLabel} 
                leftLabelId={'lblAddline1'+seq} leftLabelName={appDetailsData.label.addLine1}
                id={'addline1'+seq} name={applicantDetails.myInfo.REG_ADD_LINE1 !==null? applicantDetails.myInfo.REG_ADD_LINE1:''}/>

            <Field component={CusFormLabel} 
                leftLabelId={'lblAddline1'+seq} leftLabelName={appDetailsData.label.addLine2}
                id={'addline1'+seq} name={applicantDetails.myInfo.REG_ADD_LINE2 !== null? applicantDetails.myInfo.REG_ADD_LINE2:''}/>
            </div>
            }
        </div>
    )
}

export default PersonResiAddress;